const Engine = [
  // { code: "google", name: "Google" },
  { code: "bhashini", name: "Bhashini" },
  { code: "iiith-onemt", name: "IIITH ONEMT" },

];

export { Engine };